
import NotificationMain from "../../components/Notification-report/NotificationMain"

export const NotificationReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <NotificationMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}